export class ApiError extends Error {
    status: number

    constructor(message: string, status: number) {
        super(message)
        this.status = status
    }
}

export const apiRequest = async <T = { ok: boolean }>(url: string, method: 'POST' | 'PATCH' | 'DELETE', body: unknown = {}): Promise<T> => {
    let response: Response

    try {
        response = await fetch(url, {
            method,
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        })
    }
    catch {
        throw new ApiError('Connessione assente. Controlla la rete e riprova.', 0)
    }

    const payload = await response.json().catch(() => null) as (T & { error?: string }) | null

    if (!response.ok) throw new ApiError(payload?.error ?? 'Qualcosa non ha funzionato. Riprova.', response.status)

    return payload as T
}
